/* mqtt方法 */
import { connect } from 'mqtt'
import Store from '../../store'

const CryptoJS = require('crypto-js')
const jsCryptoDecryptRandomFn = (word, keyStr) => { // 随机字符串randomAES解密
    let key = CryptoJS.enc.Utf8.parse(keyStr)
    let decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    let decryptStr = CryptoJS.enc.Utf8.stringify(decrypt).toString()
    let str = decodeURIComponent(decryptStr)
    return str
}

// mqtt配置
let mqttOptions = {
    protocolVersion: 4, // 协议版本
    path: '/mqtt', // 路径URI
    hostname: '', // 主机名
    clientId: '', // 连接客户端ID,必须唯一,相同的ID,新连接的会将旧连接强制下线,建议于登录的用户ID关系
    clean: false, // 设置为false以在脱机时接收QoS1和2消息
    keepalive: 2, // 心跳【秒】
    connectTimeout: 5 * 1000, // 连接超时时间【毫秒】
    reconnectPeriod: 3 * 1000, // 两次重连之间的间隔时间【毫秒】
    will: { // 当连接断开时，代理发送的连接配置，主要测试连接是否可用
        topic: '/will',
        payload: 'dieout',
        qos: 1,
        retain: true
    }
};

// mqtt实例
let mqttCilent = null;
// 连接状态
let connectStatus = false

/**
 * 创建mqtt连接
 */
function mqttConnect(data) {
    mqttOptions.host = data.wsBroker
    mqttOptions.hostname = data.wsBroker
    mqttOptions.port = data.portWs
    mqttOptions.protocol = data.ws
    mqttOptions.username = jsCryptoDecryptRandomFn(data.userName, '63c9fsCnl5SCBG5U')
    mqttOptions.password = jsCryptoDecryptRandomFn(data.password, '63c9fsCnl5SCBG5U')
    mqttOptions.clientId = `bus-web-${Date.now()}`;
    mqttCilent = connect(mqttOptions);
    mqttCilent.on('connect', () => {
        console.log('MQTT已启动');
        connectStatus = true;
    });
    console.log(jsCryptoDecryptRandomFn(data.userName, '63c9fsCnl5SCBG5U'),3223);
    console.log(jsCryptoDecryptRandomFn(data.password, '63c9fsCnl5SCBG5U'),3223);

    mqttCilent.onMessageArrived = (error) => { };
    mqttCilent.on('error', function (row) {
        console.log('MQTT已断开',row);
        console.error('MQTT error:');
        connectStatus = false;
    })
    mqttCilent.on('close', function () {
        connectStatus = false;
    })
    mqttCilent.on('message', function (topic, message) {
        let msg = JSON.parse(message.toString());
        Store.dispatch('acMessage', msg);
    });

}

/**
 * 订阅mqtt
 */
function newTopic({ tpc, opt }) {
    if (connectStatus) {
        mqttCilent.subscribe(tpc, opt);
    } else {
        setTimeout(() => {
            mqttCilent.subscribe(tpc, opt);
        }, 2000)
    }
}

/**
 * 向mqtt订阅推送信息
 */
function publishTopic(tpc, msg, opt) {
    mqttCilent.publish(tpc, msg, opt)
}

/**
 * 取消mqtt订阅
 */
function cancelTopic({ tpc }) {
    if (mqttCilent) {
        mqttCilent.unsubscribe(tpc, () => {

        })
    }
}

export default {
    mqttConnect,
    newTopic,
    publishTopic,
    cancelTopic
}
